import React from 'react';

const DropdownListItem = props => {
  return <div {...props} />;
}

export default DropdownListItem